import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66c880aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-layout-main" }
const _hoisted_2 = { class: "basic-layout-sidebar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"2px","margin-right":"15px"} }, [
    /*#__PURE__*/_createElementVNode("svg", {
      t: "1698225484583",
      class: "icon",
      viewBox: "0 0 1024 1024",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "p-id": "4073",
      width: "32",
      height: "32"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M337.066667 373.333333l115.2 49.066667h2.133333L512 448l57.6-25.6h2.133333l115.2-49.066667L512 298.666667l-174.933333 74.666666zM520.533333 625.066667c-2.133333 0-4.266667 2.133333-8.533333 2.133333s-4.266667 0-8.533333-2.133333l-53.333334-23.466667-113.066666 49.066667L512 725.333333l174.933333-74.666666-113.066666-49.066667-53.333334 23.466667zM520.533333 488.533333c-4.266667 2.133333-6.4 2.133333-8.533333 2.133334s-4.266667 0-8.533333-2.133334l-59.733334-25.6-108.8 46.933334 174.933334 74.666666 174.933333-74.666666-108.8-46.933334-55.466667 25.6z",
        fill: "#3D7EFF",
        "p-id": "4074"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M512 0C228.266667 0 0 228.266667 0 512s228.266667 512 512 512 512-228.266667 512-512S795.733333 0 512 0z m232.533333 490.666667c6.4 2.133333 12.8 10.666667 12.8 19.2s-4.266667 14.933333-12.8 19.2l-119.466666 51.2 119.466666 51.2c6.4 2.133333 12.8 10.666667 12.8 19.2s-4.266667 14.933333-12.8 19.2l-226.133333 96c-2.133333 2.133333-4.266667 2.133333-6.4 2.133333s-4.266667 0-8.533333-2.133333L277.333333 669.866667c-6.4-2.133333-12.8-10.666667-12.8-19.2s4.266667-14.933333 12.8-19.2l119.466667-51.2-119.466667-51.2c-6.4-2.133333-12.8-10.666667-12.8-19.2s4.266667-14.933333 12.8-19.2l115.2-49.066667-115.2-49.066667c-6.4-2.133333-12.8-10.666667-12.8-19.2s4.266667-14.933333 12.8-19.2l226.133334-96c4.266667-2.133333 10.666667-2.133333 14.933333 0l226.133333 96c6.4 2.133333 12.8 10.666667 12.8 19.2s-4.266667 14.933333-12.8 19.2l-115.2 49.066667 115.2 49.066667z",
        fill: "#3D7EFF",
        "p-id": "4075"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "通用CMS")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-subtitle" }, "主菜单", -1))
const _hoisted_5 = { class: "sidebar-menu" }
const _hoisted_6 = { style: {"text-align":"center","margin-left":"15px"} }
const _hoisted_7 = { style: {"text-align":"center","margin-left":"15px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-grid",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_9 = { style: {"text-align":"center","margin-left":"15px"} }
const _hoisted_10 = { class: "sider-bottom" }
const _hoisted_11 = { class: "sider-bottom-user" }
const _hoisted_12 = { style: {"font-weight":"500","margin":"0 15px"} }
const _hoisted_13 = { class: "basic-layout-content" }
const _hoisted_14 = { class: "navigation" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation-search" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }),
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    placeholder: "搜索"
  }),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-justify" })
], -1))
const _hoisted_16 = { class: "navigation-time-tools" }
const _hoisted_17 = { class: "navigation-tools" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-book" })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person" })
], -1))
const _hoisted_22 = { class: "content" }

import { defineOptions, reactive, ref } from 'vue';
import { ElAvatar } from 'element-plus';
import "@element-plus/icons-vue";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { MenuRoutes } from "@/router/routes";
import router from '@/router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  ...{ name: "BasicLayout" },
  __name: 'index',
  setup(__props) {



const store = useStore();

const activeIndex = ref(router.currentRoute.value.path);

const data = reactive({
    avatar: {
        size: 35,
        src: require("@/assets/avatar.svg")
    },
    userInfo: {
        username: "admin",
        nickname: "管理员",
        email: "admin@admin.com",
        phone: "13888888888"
    }
});

 /**
  * @description 退出登录
  * 
  */
function logout(){
    window.localStorage.removeItem("token");
    store.commit('auth/setloginStatus', false);
    store.commit('auth/setToken', null);
    store.commit('user/updateUser', null);
    router.replace("/login");
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_menu, {
          "default-active": activeIndex.value,
          class: "el-menu-vertical-demo",
          onSelect: _cache[0] || (_cache[0] = () => {}),
          "background-color": "#ffffff",
          "text-color": "#333",
          router: true,
          style: {"height":"auto","border":"none"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MenuRoutes), (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (item.children.length > 1)
                  ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                      key: 0,
                      index: item.redirect || item.path
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass([
                                    'bi',
                                    'bi-' + item.meta.icon,
                                ]),
                          style: {"font-size":"24px"}
                        }, null, 2),
                        _createTextVNode(),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                            index: child.path
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass([
                                        'bi',
                                        'bi-' + child.meta.icon,
                                    ]),
                                style: {"font-size":"24px"}
                              }, null, 2),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(child.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        }), 256))
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  : (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      index: item.redirect
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
              ], 64))
            }), 256))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(ElAvatar), {
            shape: "circle",
            src: ""
          }),
          _createElementVNode("span", _hoisted_12, _toDisplayString(data.userInfo.username), 1),
          _createVNode(_component_el_button, {
            type: "text",
            onClick: logout
          }, {
            default: _withCtx(() => [
              _createTextVNode("退出")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_button, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString("最近一次登录时间：" + new Date().toLocaleString()), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_router_link, { to: "/notification" }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/message" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/task" }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/user" }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}
}

})